import DomainResource from './DomainResource';
import merge from 'lodash/merge';

export default class BN_Role extends DomainResource {
    static __className = 'BN_Role';

    __objectStructure = {
        name: String,
        active: Boolean,
        permissions: [String],
    };

    __objectDefaults = {
        experimental: false,
    };

    constructor(constructJson, className = 'BN_Role') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
